import React from 'react'

export const InquiryIcon = ({
    iconColor = '#333333',
}: {
    iconColor: string
}) => {
    return (
        <span>
            <svg
                xmlns="http://www.w3.org/2000/svg"
                width="32"
                height="33"
                viewBox="0 0 32 33"
                fill="none"
            >
                <path
                    d="M21.9505 12.4289H29.3333L24.6288 7.54275C23.1142 5.97062 21.2276 4.84006 19.1586 4.26472C17.0895 3.68939 14.9111 3.68955 12.8421 4.26521C10.7732 4.84086 8.8867 5.97171 7.37233 7.54408C5.85795 9.11645 4.76906 11.0749 4.2151 13.2226M2.66814 28.2343V20.5711M2.66814 20.5711H10.051M2.66814 20.5711L7.37115 25.4573C8.88575 27.0294 10.7724 28.16 12.8414 28.7353C14.9104 29.3106 17.0889 29.3105 19.1579 28.7348C21.2268 28.1592 23.1133 27.0283 24.6276 25.4559C26.142 23.8836 27.2309 21.9251 27.7849 19.7774M29.3333 4.76577V12.4259"
                    stroke={iconColor}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16 21.8333V16.4999M13.3333 19.3282L14.1147 19.914C15.1556 20.6953 16.8436 20.6953 17.8853 19.914C18.9271 19.1327 18.9271 17.8669 17.8853 17.0856C17.3653 16.6945 16.6827 16.4999 16 16.4999M16 16.4999C15.3556 16.4999 14.7111 16.3043 14.2196 15.9141C13.2365 15.1328 13.2365 13.867 14.2196 13.0857C15.2027 12.3044 16.7973 12.3044 17.7805 13.0857L18.1493 13.379M16 16.4999L16 11.1667"
                    stroke={iconColor}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        </span>
    )
}
